/**
 * GET /patients query mapping (backend):
 * - name — name OR registration OR phone when the string has ≥3 digits (use for omnibox text)
 * - search — optional; many APIs only filter on `name`, so we send `name` for plain text
 * - registrationNumber — registration field only (reg:… prefix)
 * - phone — phone match (digits-only / phone-ish input)
 */

const LOOSE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizePhoneDigits(input) {
  return String(input || "").replace(/\D/g, "");
}

/** Phone-ish input with enough digits (aligned with Billing). */
export function isPhoneSearchQuery(trimmed) {
  const digits = normalizePhoneDigits(trimmed);
  if (digits.length < 4) return false;
  return /^[\d\s\-+().]+$/.test(trimmed);
}

/**
 * Returns a fragment to merge into GET /patients params (omit empty branchId etc. yourself).
 * Uses at most one of: phone | registrationNumber | name.
 */
export function buildPatientListQueryParams(q) {
  const trimmed = String(q || "").trim();
  if (!trimmed) return {};

  const regPrefix = /^(?:#)?reg(?:istration)?\s*[:#]\s*(.+)$/i;
  const regMatch = trimmed.match(regPrefix);
  if (regMatch && String(regMatch[1] || "").trim()) {
    return { registrationNumber: String(regMatch[1]).trim() };
  }

  if (isPhoneSearchQuery(trimmed)) {
    const digits = normalizePhoneDigits(trimmed);
    if (digits.length >= 3) return { phone: digits };
  }

  if (LOOSE_EMAIL.test(trimmed)) {
    return { name: trimmed };
  }

  // Plain text / mixed: backend `name` matches patient name + registration + phone when ≥3 digits in query.
  return { name: trimmed };
}
